import dynamicWidgetList from './DynamicWidgetList';

export default [dynamicWidgetList];
